import CategoryHead from "@/components/categoryHead"
import { FC, useCallback, useEffect, useState } from "react"
import styles from "./styles/messagedetails.module.css"
import Footer from "@/components/footer"
import Back from "@/components/back"
import useAxios from "@/hooks/useAxios"
import useUser from "@/hooks/useUser"
import Empty from "@/components/empty"
import useRoleAuth from "@/hooks/useRoleAuth"
import u, { cancelAllPreviousFetchRequests } from "@/util"
import Img from "@/components/img"
import { appendHost } from "@/const/append";
import { useParams } from "react-router-dom"
import Button from "@/components/button"

const UserMessageDetail: FC = () => {
    useRoleAuth()
    const { id } = useParams()
    const [user] = useUser()
    const { req } = useAxios("message/details", "post");
    const [data, setData] = useState<any>()
    const fetchDetails = useCallback(async (page?: any) => {
        if (!user?.token) return;
        const res = await req({
            token: user?.token,
            id: id
        });

        console.log('data message  ', res)
        if (res?.data?.message) {
            setData(res?.data?.message)
        }
    }, [user])

    useEffect(() => {
        fetchDetails()
    }, [fetchDetails])

    const handleJump = useCallback((code: any) => {
        if(code){
            return u.open("/user/redeem?code="+code);
        }else{
            return;
        }
    }, [])

    return (
        <CategoryHead>
            <div className="plr mh700 mt80">
                <div className="mw1100 mb10">
                    <Back>消息中心</Back>
                    {
                       data && <>
                       <hr/>
                        <div className={styles.container}>
                                <div className={styles.wrapper}>
                                    <div className={styles.contentwrapper}>
                                        <Img src={appendHost("/images/xiaoxi.png")} width={50} height={50} cls={styles.img}/>
                                        <div className={styles.title}>系统消息</div>
                                        <div className={styles.time}>{u.fmtDateSince(data?.insert_time * 1000)}</div>
                                    </div>
                                </div>
                                <div className={data.is_redeemed && data.is_redeemed === "1" ? styles.msgline : ''}>
                                <div className={styles.desc} style={{whiteSpace: "pre-wrap"}} dangerouslySetInnerHTML={{ __html:data?.message}}></div>
                                {/* {!!data.url && <>
                                <div className="fl align_center justify_between" style={{placeContent:'center'}}>
                                    <Button event={()=>{handleJump(data?.url)}} cls={`mt20 btn_sty2 ${u.themeBtnCls()} width100`}>点击兑换</Button>
                                    </div>
                                </>} */}
                                {data.is_redeemed && data.is_redeemed === "1" && <>
                                    <div className={styles.redeemed}>~ 已兑换</div>
                                </>}
                                {data.is_redeemed && data.is_redeemed === "2" && data.type && data.type === 2 && <>
                                <div className="fl align_center justify_between" style={{placeContent:'center'}}>
                                    <Button event={()=>{handleJump(data?.code)}} cls={`mt20 btn_sty2 ${u.themeBtnCls()} width100`}>点击兑换</Button>
                                    </div>
                                </>}
                                </div>
                            </div>
                       </>
                    }
                    {!data && <Empty></Empty>}
                </div>
            </div>
            <Footer />
        </CategoryHead>
    )
}
export default UserMessageDetail